import { inject } from '@angular/core';
import type { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import type { Observable } from 'rxjs';
import { forkJoin } from 'rxjs';
import type { IState } from '../../../shared/models/options.interface';
import { SalesLookupService } from '../../../shared/services/sales-lookup.service';

export const layoutResolver: ResolveFn<Observable<IState[][]>> = (
  _route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot,
  salesLookupService: SalesLookupService = inject(SalesLookupService)
) => {
  const runFetches = [salesLookupService.fetchStates()];

  return forkJoin(runFetches);
};
